import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  NursingHomeInformationAlert,
  RegularAssistanceAlert,
} from '../../../components/AdditionalFormNeededAlerts';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['claim-information-nursing-home-title']),
    claimantLivesInANursingHome: yesNoUI({
      title: 'Do you live in a nursing home?',
    }),
    'view:nursingHomeInformationAlert': {
      'ui:description': NursingHomeInformationAlert,
      'ui:options': {
        hideIf: formData => formData?.claimantLivesInANursingHome !== true,
      },
    },
    claimantNeedsRegularAssistance: yesNoUI({
      title:
        'Do you need the regular assistance of another person, have severe visual problems, or are generally confined to your immediate surroundings?',
    }),
    'view:regularAssistanceAlert': {
      'ui:description': RegularAssistanceAlert,
      'ui:options': {
        hideIf: formData => formData?.claimantNeedsRegularAssistance !== true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['claimantLivesInANursingHome', 'claimantNeedsRegularAssistance'],
    properties: {
      claimantLivesInANursingHome: yesNoSchema,
      'view:nursingHomeInformationAlert': {
        type: 'object',
        properties: {},
      },
      claimantNeedsRegularAssistance: yesNoSchema,
      'view:regularAssistanceAlert': {
        type: 'object',
        properties: {},
      },
    },
  },
};
